export default __webpack_public_path__ + "static/media/css.e2fad950.svg";